import './style.css';
import React, { Fragment, useEffect, useState } from 'react'
import QRCode from "react-qr-code";
import { http_request } from '../../../libs/connection';
import { BASE_ROUTE, ROOT_ADDR, SESSION_EXPIRED_CODE } from '../../../config';
import { createTimeString, numberToCash, numberWithComma, auth, getOrderStatus } from '../../../libs/lib';
import { Button, FormCheck, FormControl, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { BsArrowReturnLeft } from 'react-icons/bs';
import Progress from '../../../components/progress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Decimal from 'decimal.js';

function PurchaseDetail() {
    const MAX_COLUMNS = 6;
    const LINES_PER_ROW = 2;//每一个 row 有2行组成所以空白行也 * 2
    const navigate = useNavigate();
    const url_params = useParams();
    const location = useLocation();
    const { pathname } = location;
    const { ch_no } = url_params;
    const [is_loading, setLoadingStatus] = useState(false);
    const [order, setOrder] = useState({});
    const [editing_order, setEditingOrder] = useState({});
    const [empty_rows, setEmptyRows] = useState([LINES_PER_ROW]);
    const [order_editor_show, showOrderEditor] = useState(false);
    const [qc_remk, setQCRemk] = useState('');
    const [company_fd_no, setCompanyFDNo] = useState('');
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [success_message, setSuccessMessage] = useState('');
    const [error_message, setErrorMessage] = useState('');
    const [ship_orders, setShipOrders] = useState([]);
    const [ship_order_list_viewer_show, showShipOrderListViewer] = useState(false);


    useEffect(()=>{
        loadOrder();
        loadShipOrders();
    }, [pathname, ch_no]);

    function loadOrder(){
        if(!ch_no) return;
        let params = {
            ch_no
        };
        http_request('/purchaseOrder/get', 'POST', params).then(res=>{
            if(res.success){
                let raw_data = res.data.purchase_orders;
                let order = raw_data[0] ?? {};
                order.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>{
                    let r = Object.assign({}, row);
                    r.ch_qty2_number = calculateQtyNumber(row);
                    return r;
                });
                for(let i = 0 ; i < order.detail.length ; i++){
                    delete order.detail[i].detail;
                }
                let epr = 4 - order.detail.length;
                if(epr <= 0 ) epr = 1;
                epr *= LINES_PER_ROW;
                setEmptyRows((new Array(epr)).fill(1));
                setOrder(order);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function loadShipOrders(){
        if(!auth("global.purchaseShipOrder")) return;
        let params = {
            ch_no,
            rows: 9999
        };
        http_request('/purchaseShipOrder/list', 'POST', params).then(res=>{
            if(res.success){
                setShipOrders((res.data.purchase_ship_orders || []));
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function submitOrder(){
        if(!company_fd_no?.length || company_fd_no?.length > 20){
          setErrorMessage('出货单号不可留白');
          showErrorToast(true);
          return;
        }
        let params = {
            ch_no,
            qc_remk,
            company_fd_no,
            detail: JSON.parse(JSON.stringify((editing_order.detail.filter(d=>d.checked)))).map(row=>{
                row.ch_qty2 = row.ch_qty2_number;
                return row;
            })
        };
        
        setLoadingStatus(true);
        http_request('/purchaseOrder/ship', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                showOrderEditor(false);
                showSuccessToast(true);
                setSuccessMessage('已建立出货单');
                setErrorMessage('');
                let new_list = [...ship_orders];
                new_list.push(res.data.purchase_ship_order);
                setShipOrders(new_list);
            }else if(res.message === SESSION_EXPIRED_CODE){
                showOrderEditor(false);
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                showErrorToast(true);
                setErrorMessage(res.message);
            }
        })
    }
    function createShipOrder(){
        let new_form = Object.assign({}, order);
        new_form.detail = [...(new_form.detail || [])]; 
        setEditingOrder(new_form);
        setQCRemk('');
        setCompanyFDNo('');
        showOrderEditor(true);
    }
    function deleteShipOrder(fd_no, i){
        let rs = window.confirm(`确定删除出货单吗?`);
        if(!rs) return;

        let params = { fd_no };
        setLoadingStatus(true);
        http_request('/purchaseShipOrder/delete', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                showSuccessToast(true);
                setSuccessMessage('已删除出货单');
                setErrorMessage('');
                let new_list = [...ship_orders];
                new_list.splice(i, 1);
                setShipOrders(new_list);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                showErrorToast(true);
                setErrorMessage(res.message);
            }
        });
    }
    function calculateQtyNumber(row){
      let n = row.ch_qty2 - row.ch_puqty + row.ch_reqty + row.ch_reqty2;
      if(n < 0) n = 0;
      return n;
    }
    return (
        <div id="page-purchase-detail" className='page'>
            <Progress show={is_loading} variant="primary" />
            <Modal
                show={ship_order_list_viewer_show}
                onHide={()=>{ showShipOrderListViewer(false); }}
                centered
            >
                <Modal.Body className='p-5 d-flex flex-column align-items-center justify-content-center'>
                    {
                        ship_orders.map((ship_order, s)=><div key={s} className="qr_block">
                            <QRCode
                                size={256}
                                className='qr-code mb-2'
                                value={`${ROOT_ADDR}/erp/purchase/ship/detail/${ship_order.fd_no}`}
                            />
                            <div className='fw-bold'>{ship_order.fd_no}</div>
                            <div>建立日期：{createTimeString('y-m-d', ship_order.date)}</div>
                            <div>签收日期：{ship_order.fd_date ? createTimeString('y-m-d', ship_order.fd_date) : '--'}</div>
                            <div>签收状态：[{getOrderStatus(ship_order.temp_no, ship_order.result)}]{ship_order.temp_no ? '已签收' : (ship_order.result ||'').replace(/^\d+\./, '')}</div>
                            <div>厂商出货单号：{ship_order.company_fd_no || '--'}</div>
                            <div className='mb-3'>备註：{ship_order.qc_remk}</div>
                            <div className='mb-3 mt-1 d-flex align-items-center justify-content-between'>
                                <Button 
                                    variant='danger' 
                                    size='sm' 
                                    className='px-2'
                                    onClick={()=>{
                                        deleteShipOrder(ship_order.fd_no, s);
                                    }}
                                    disabled={getOrderStatus(ship_order.temp_no, ship_order.result) !== '尚未签收'}
                                >
                                    删除出货单
                                </Button>
                                <Button 
                                    variant='success' 
                                    size='sm' 
                                    className='px-4'
                                    onClick={()=>{
                                        navigate(`${BASE_ROUTE}/purchase/ship/detail/${ship_order.fd_no}`);
                                    }}
                                >
                                    打开出货单
                                </Button>
                            </div>
                        </div>)
                    }
                </Modal.Body>
                <Modal.Footer className='d-flex align-items-center justify-content-end'>
                    <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showShipOrderListViewer(false); }}>关闭</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={order_editor_show}
                onHide={()=>{ showOrderEditor(false); }}
                size='lg'
            >
                <Modal.Header>
                    <span className='fs-5'>建立出货单</span>
                </Modal.Header>
                <Modal.Body>
                    <table>
                        <tbody>
                            <tr>
                                <td>{editing_order.ch_no}</td>
                            </tr>
                            <tr>
                                <td>{editing_order.ch_date}</td>
                            </tr>
                            <tr>
                                <td>{editing_order.cu_name}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        {
                            (editing_order.detail || []).map((row, r)=><div key={r} className={`p-3 mt-2 border ${!(row.checked) && 'text-secondary bg-light'}`}>
                                <div className='border-bottom mb-3 pb-2'>
                                    <FormCheck
                                        type="switch"
                                        size={30}
                                        checked={row.checked || false}
                                        onChange={()=>{
                                            let new_form = Object.assign({}, editing_order);
                                            new_form.detail = [...(new_form.detail || [])];
                                            new_form.detail[r].checked = !new_form.detail[r].checked;
                                            setOrder(new_form);
                                        }}
                                        label={row.ch_apno}
                                    />
                                </div>
                                <ul className=''>
                                    <li>{row.ch_seq}</li>
                                    <li>{row.el_name1}</li>
                                    <li>{row.ch_apno}</li>
                                    <li>{row.el_no}</li>
                                    <li>出货数量上限：{calculateQtyNumber(row)}</li>
                                    <li>出货数量：<input 
                                        style={{ width: 80 }}
                                        value={row.ch_qty2_number} 
                                        disabled={!(row.checked)}
                                        onChange={e=>{
                                            var v = e.currentTarget.value;
                                            let new_form = Object.assign({}, editing_order);
                                            new_form.detail = [...(new_form.detail || [])];
                                            new_form.detail[r].ch_qty2_number = v;
                                            setOrder(new_form);
                                    }} />{row.ch_unit}</li>
                                    <li>单价：{numberToCash(row.ch_price)}</li>
                                </ul>
                            </div>)
                        }
                    </div>
                    <div className='mt-3'>
                        <FormControl
                            className='mb-2'
                            placeholder="厂商出货单号(至多20码)"
                            value={company_fd_no}
                            maxLength={20}
                            onChange={e=>{
                                setCompanyFDNo(e.currentTarget.value.toUpperCase());
                            }}
                        />
                        <FormControl
                            as="textarea"
                            rows={4}
                            value={qc_remk}
                            onChange={e=>{
                                setQCRemk(e.currentTarget.value);
                            }}
                            placeholder='备註'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='f-flex justify-content-between'>
                    <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showOrderEditor(false); }}>取消</Button>
                    <Button 
                        size='sm' 
                        variant='success' 
                        className='px-3'
                        disabled={(editing_order.detail || []).filter(row=>row.checked).length === 0}
                        onClick={()=>{ submitOrder(); }}
                    >建立出货单</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer 
                position='middle-bottom'
                style={{ zIndex: 1056 }}
                >
                <Toast 
                    show={success_toast_show} 
                    onClose={()=>{ showSuccessToast(false); }}
                    delay={2000}
                    autohide
                    bg="success"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">已完成</strong>
                    </Toast.Header>
                    <Toast.Body>{success_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <ToastContainer
                position='middle-bottom'
                style={{ zIndex: 1056 }}
            >
                <Toast 
                    show={error_toast_show} 
                    onClose={()=>{ showErrorToast(false); }}
                    delay={3000}
                    autohide
                    bg="danger"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">建立失败</strong>
                    </Toast.Header>
                    <Toast.Body>{error_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <div className={`bg-white d-block content`}>
                <div className={`d-flex align-items-center justify-content-between py-3 px-2 head-container`}>
                    <span className='text-secondary pe-5 d-flex align-items-center cursor-pointer' onClick={()=>{ navigate(-1) }}>
                        <BsArrowReturnLeft size={20} className='pe-2' />
                        <span>返回</span>
                    </span>
                    <span>
                        {
                            auth('global.purchaseShipOrder') && <Button 
                                size='sm' 
                                variant='danger'
                                className='px-2 me-1' 
                                disabled={ship_orders.length === 0} 
                                onClick={()=>{ showShipOrderListViewer(true); }}
                            >
                                出货单列表
                            </Button>
                        }
                        <Button size='sm' variant='success' className='px-2' disabled={Object.keys(order).length === 0} onClick={()=>{ createShipOrder(); }}>建立出货单</Button>
                    </span>
                </div>
                <div className={`overflow-auto table-container`}>
                    <table className={`border border-dark m-auto  dtable`}>
                        <tbody className="underline">
                            <tr>
                                <td colSpan={3}>厂商名称：{order.cu_name}</td>
                                <td className='text-end'>页：{1}/{1}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>厂商地址：{order.cu_addr}</td>
                                <td colSpan={2}>採购单号：{ch_no}</td>
                            </tr>
                            <tr>
                                <td>电　　话：{order.cu_tel}</td>
                                <td>传　真：{order.cu_fax}</td>
                                <td>联络人：{order.cu_touch}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody className='underline text-center'>
                            <tr className='fw-bold'>
                                <td className='border border-dark border-top-0'>项次</td>
                                <td className='border border-dark border-top-0'>请购单号</td>
                                <td className='border border-dark border-top-0'>品名</td>
                                <td className='border border-dark border-top-0'>交货日期</td>
                                <td className='border border-dark border-top-0'>单位</td>
                                <td className='border border-dark border-top-0'>採购数量</td>
                                <td className='border border-dark border-top-0'>单价</td>
                                <td className='border border-dark border-top-0'>金额</td>
                            </tr>
                            <tr className='underline fw-bold'>
                                <td className='border border-dark border-top-0' colSpan={2}>料品编号</td>
                                <td className='border border-dark border-top-0'>规格</td>
                                <td className='border border-dark border-top-0'>品名</td>
                                <td className='border border-dark border-top-0' colSpan={5}>备註</td>
                            </tr>
                            {
                                (order.detail || []).map((row, r)=><Fragment key={r}>
                                    <tr className="underline-dashed">
                                        <td className='tdx-border text-start'>{row.ch_seq}</td>
                                        <td className='tdx-border text-start'>{row.ch_apno}</td>
                                        <td className='tdx-border text-start'>{row.el_name1}</td>
                                        <td className='tdx-border text-start'>{row.ch_redat}</td>
                                        <td className='tdx-border'>{row.ch_unit}</td>
                                        <td className='tdx-border'>{row.ch_qty2}</td>
                                        <td className='tdx-border text-start'>{numberWithComma(row.ch_price)}</td>
                                        <td className='tdx-border text-start'>{numberWithComma(Decimal.mul(row.ch_price || 0, row.ch_qty2 || 0))}</td>
                                    </tr>
                                    <tr className="underline">
                                        <td colSpan={2} className="tdx-border text-start">{row.el_no}</td>
                                        <td className="tdx-border text-start">{row.el_size}</td>
                                        <td className="tdx-border text-start">{row.el_name1}</td>
                                        <td colSpan={5} className="tdx-border text-start">{row.ch_remkd}</td>
                                    </tr>
                                </Fragment>)
                            }
                            {
                                empty_rows.map((row, r)=><tr key={r}><td colSpan={MAX_COLUMNS}>　</td></tr>)
                            }
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody>
                            <tr>
                                <td colSpan={2} className='tdx-border'>本页小计(未税)</td>
                                <td colSpan={2} className='tdx-border text-end'>{numberWithComma(order.ch_amt)}</td>
                                <td className='tdx-border'>本页税额</td>
                                <td colSpan={2} className='tdx-border text-end'>{numberWithComma(order.ch_tax)}</td>
                                <td className='tdx-border'>本页合计(含税)</td>
                                <td className='tdx-border text-end'>{numberWithComma(Decimal.add(order.ch_amt || 0, order.ch_tax || 0))}</td>
                            </tr>
                            <tr>
                                <td className='td-border'>付款币别</td>
                                <td className='td-border'>{order.od_name}</td>
                                <td className='td-border'>其他费用</td>
                                <td className='td-border' colSpan={4}></td>
                                <td className='td-border'>小计(未税)</td>
                                <td className='td-border text-end'>{numberWithComma(order.ch_amt)}</td>
                            </tr>
                            <tr>
                                <td className='td-border'>付款方式</td>
                                <td className='td-border' colSpan={6}>{order.ch_condi}</td>
                                <td className='td-border'>{order.taxiddesc}</td>
                                <td className='td-border text-end'>{order.ch_tax}</td>
                            </tr>
                            <tr>
                                <td className='td-border'>付款条件</td>
                                <td className='td-border' colSpan={6}>{order.ch_charg}</td>
                                <td className='td-border'>总金额(含税)</td>
                                <td className='td-border text-end'>{numberWithComma(Decimal.add(order.ch_amt || 0, order.ch_tax || 0))}</td>
                            </tr>
                            <tr>
                                <td className='td-border'>指送地址</td>
                                <td className='td-border' colSpan={8}>{order.ch_shipto}</td>
                            </tr>
                            <tr>
                                <td className='td-border'>备<br />註</td>
                                <td className='td-border' colSpan={5}>
                                    {order.ch_remk}
                                </td>
                                <td className='td-border'>厂商<br />签回</td>
                                <td className='td-border' colSpan={2}></td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colSpan={9}>{order.ar_relna}</td>
                            </tr>
                            <tr>
                                <td colSpan={9}>　</td>
                            </tr>
                            <tr>
                                <td colSpan={9}>{order.ar_asgna}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PurchaseDetail;
